module.exports = __webpack_public_path__ + "assets/img/12a.cb4e5063.jpg";